import ReactGA from 'react-ga4';

// Initialize Google Analytics
export const initGA = () => {
  const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
  
  if (GA_MEASUREMENT_ID) {
    ReactGA.initialize(GA_MEASUREMENT_ID);
    console.log('Google Analytics initialized with ID:', GA_MEASUREMENT_ID);
  } else {
    console.warn('Google Analytics Measurement ID not found. Please set REACT_APP_GA_MEASUREMENT_ID in your environment variables.');
  }
};

// Track page views
export const trackPageView = (path) => {
  ReactGA.send({ hitType: "pageview", page: path });
};

// Track custom events
export const trackEvent = (category, action, label = null, value = null) => {
  ReactGA.event({
    category: category,
    action: action,
    label: label,
    value: value
  });
};

// Track user registration
export const trackRegistration = (planType) => {
  trackEvent('User', 'Registration', planType);
};

// Track plan selection
export const trackPlanSelection = (planName, planPrice) => {
  trackEvent('Pricing', 'Plan Selected', planName, planPrice);
};

// Track payment initiation
export const trackPaymentStart = (planName, amount, currency) => {
  trackEvent('Payment', 'Payment Started', planName, amount);
};

// Track payment completion
export const trackPaymentSuccess = (planName, amount, currency) => {
  trackEvent('Payment', 'Payment Success', planName, amount);
};

// Track payment failure
export const trackPaymentFailure = (planName, error) => {
  trackEvent('Payment', 'Payment Failed', `${planName} - ${error}`);
};

// Track contact form submission
export const trackContactForm = () => {
  trackEvent('Contact', 'Form Submitted');
};

// Track feature interaction
export const trackFeatureClick = (featureName) => {
  trackEvent('Features', 'Feature Clicked', featureName);
};

// Track download
export const trackDownload = (downloadType) => {
  trackEvent('Download', 'File Downloaded', downloadType);
};

// Track social media clicks
export const trackSocialClick = (platform) => {
  trackEvent('Social', 'Social Media Clicked', platform);
};

// Track newsletter subscription
export const trackNewsletterSignup = () => {
  trackEvent('Newsletter', 'Subscription');
};

// Track FAQ interaction
export const trackFAQInteraction = (question) => {
  trackEvent('FAQ', 'Question Viewed', question);
};

// Track demo request
export const trackDemoRequest = (source) => {
  trackEvent('Demo', 'Request Demo', source);
};

// Track pricing page view
export const trackPricingPageView = () => {
  trackEvent('Pricing', 'Page Viewed');
};

// Track features page view
export const trackFeaturesPageView = () => {
  trackEvent('Features', 'Page Viewed');
};

// Track download page view
export const trackDownloadPageView = () => {
  trackEvent('Download', 'Page Viewed');
};

// Track blog interaction
export const trackBlogInteraction = (action, blogTitle) => {
  trackEvent('Blog', action, blogTitle);
};

// Track video play
export const trackVideoPlay = (videoTitle) => {
  trackEvent('Video', 'Video Played', videoTitle);
};

// Track scroll depth
export const trackScrollDepth = (percentage) => {
  trackEvent('Engagement', 'Scroll Depth', `${percentage}%`);
};

// Track time on page
export const trackTimeOnPage = (pageName, seconds) => {
  trackEvent('Engagement', 'Time on Page', pageName, seconds);
}; 